<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="tabChange">
      <el-tab-pane label="订单列表" name="orderlist">
        <order-list :visible="activeName === 'orderlist'"></order-list>
      </el-tab-pane>
      <el-tab-pane label="订单明细" name="orderline">
        <order-line :visible="activeName === 'orderline'"></order-line>
      </el-tab-pane>
      <el-tab-pane label="订单收款记录" name="orderlog">
        <order-log :visible="activeName === 'orderlog'"></order-log>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import orderList from "./list.vue";
import orderLine from "./line.vue";
import orderLog from "./log.vue";
import { PageModule } from "@/store/module/page";

export default {
  name: "orderlist",
  components: {
    orderList,
    orderLine,
    orderLog,
  },
  data() {
    return {
      activeName: "orderlist",
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.activeName = this.$route.query.tab;
    } else {
      const cache = PageModule.pageInfo.orderManage;
      if (cache.tab) {
        this.activeName = cache.tab;
      } else {
        this.activeName = "orderlist";
        PageModule.SET_PAGE_INFO({
          name: "orderManage",
          key: "tab",
          value: "orderlist",
        });
      }
    }
    if (this.$route.query.from === "experienceToDetailed") {
      this.activeName = "orderline";
    }
  },
  methods: {
    tabChange(v) {
      PageModule.SET_PAGE_INFO({
        name: "orderManage",
        key: "tab",
        value: v.name,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  /deep/.el-tabs__active-bar {
    transition: none;
  }
}
</style>
